import { Button, useTheme } from "capsule"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"
import { Text } from "react-native-paper"

import { MigrationFinalizedNS } from "../../features/i18n/constants"
import { useMigrationAccount } from "../../features/Providers/MigrationAccountProvider"

const MigrationFinalizedScreen = () => {
  const {
    colors: {
      black,
      surface: { background },
      accent,
    },
    dimensions: { spacing },
  } = useTheme()
  const { t } = useTranslation(MigrationFinalizedNS)

  const { setIsMigrating } = useMigrationAccount()

  const s = useMemo(
    () => ({
      view: [
        styles.view,
        {
          backgroundColor: background,
          paddingHorizontal: spacing * 2,
        },
      ],
      separator: [styles.separator, { backgroundColor: black.separator }],
      section: [styles.section, { backgroundColor: accent, padding: spacing / 2 }],
      bold: styles.bold,
      button: styles.button,
    }),
    [background, black.separator, accent, spacing],
  )
  const handleStart = () => {
    setIsMigrating?.(false)
  }
  return (
    <View style={s.view}>
      <Text style={[s.bold]}>{t("done")}</Text>
      <Text>{t("accountUpdated")}</Text>
      <View style={s.section}>
        <Text>{t("explanation")}</Text>
      </View>
      <Button style={s.button} onPress={handleStart}>
        {t("button")}
      </Button>
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    gap: 20,
    paddingVertical: 40,
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "flex-start",
  },
  section: {
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    borderRadius: 8,
  },
  bold: {
    fontWeight: "bold",
  },
  button: {
    width: "100%",
    height: 40,
  },
  separator: {
    height: 1,
    width: "60%",
  },
  icon: {
    marginBottom: 20,
    marginRight: 28,
    width: 122,
    height: 96,
  },
})

export default MigrationFinalizedScreen
